export default {
  LowerPrimaryIsBetter: 'lowerPrimaryIsBetter',
  HigherPrimaryIsBetter: 'higherPrimaryIsBetter',
}
